export default {
  "errors.auth.invalidPasswordOrEmail": {
    en: "Wrong email or password",
    es: "Email o contraseña erróneo.",
  },
  "errors.auth.invalidTwoFactorCode": {
    en: "Verification code is either wrong or expired",
    es: "El código de acceso es incorrecto o ha expirado.",
  },
  "errors.auth.invalidPassword": {
    en: "Wrong password",
    es: "Contraseña errónea.",
  },
  "errors.auth.blockedUser": {
    en: "User is blocked",
    es: "El usuario está bloqueado.",
  },
  "errors.auth.failedAttempts": {
    en: "Login failed. Try again __$1__",
    es: "Login fallido. Inténtalo de nuevo __$1__",
  },
  "errors.auth.noDnsEmail": {
    en: "It's a fake email.",
    es: "El email introducido es falso.",
  },
  "errors.auth.disposableEmail": {
    en: "It's a temporary email.",
    es: "El email introducido es temporal.",
  },
  "errors.auth.registeredEmail": {
    en: "You already have a Quoters account with this email. Please, log in.",
    es: "Ya tienes una cuenta en Quoters con este email. Inicia sesión.",
  },
  "errors.contact.alreadyExist": {
    en: "There is already a contact with this email",
    es: "Ya existe un contacto con este email",
  },
  "errors.cardErrors.cardDeclined": {
    en: "Your card was declined.",
    es: "Tu tarjeta ha sido rechazada.",
  },
  "errors.cardErrors.zipCodeFailed": {
    en: "ZIP code you supplied failed to validate.",
    es: "Ha fallado la validación del código postal.",
  },
  "errors.cardErrors.cvcFailed": {
    en: "Your card's CVV is incorrect.",
    es: "El código de seguridad de la tarjeta es incorrecto.",
  },
  "errors.cardErrors.insufficientFunds": {
    en: "Your card has insufficient funds.",
    es: "Tu tarjeta no tiene fondos suficientes.",
  },
  "errors.cardErrors.cardExpired": {
    en: "Your payment was rejected.",
    es: "Tu tarjeta ha sido rechazada.",
  },
  "errors.cardErrors.processingError": {
    en: "An error occurred while processing your card. Try again later.",
    es: "Ha ocurrido un error mientras procesabamos tu pago. Intentalo de nuevo mas tarde.",
  },
  "errors.cardErrors.scaFailed": {
    en: "SCA Validation failed.",
    es: "Ha fallado la validación SCA.",
  },
  "errors.quotes.codeIsNotUnique": {
    en: "Code already exists.",
    es: "El código ya existe.",
  },
  "errors.invitations.onlyOnceDay": {
    en: "You can only send one invitation to the same email once a day.",
    es: "Sólo puedes reenviar una invitación al mismo email una vez al día.",
  },
};
